import { useState, useEffect, useRef } from "react";
import { ChangeAlertCallbackType } from "../../../Root";
import { FeatureService } from "../../../../services/FeatureService";

export const useCustomerAdd = (open: boolean, changeAlert: ChangeAlertCallbackType, customer) => {
    const featureService = useRef<FeatureService>();
    const [isValidForm, setIsValidForm] = useState<boolean>(true);
    const [featureList, setFeatureList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({});
    const [search, setSearch] = useState("");
    const [zPos, setZPos] = useState(45);
    const [form, setForm] = useState({
        feature_uuid: "",
        customers: [],
    });

    const getData = async (filters) => {
        setLoading(true);
        setZPos(1);

        let request = {
            data: {
                page_number: 1,
                results_per_page: 50,
                filters: filters,
            },
        };

        if (filters && Object.values(filters)[0]) {
            request.data["filters"] = filters;
        }

        const response = await featureService.current.featureList(request);
        setFeatureList(response.data.widget[0].data.content || []);
        setZPos(45);
        setLoading(false);
    };

    const changeValueSearch = (type, e) => {
        let f = filters;
        f[type] = e.target.value.trimStart();
        setSearch(e.target.value.trimStart());
        type === "uuid" ? delete f["feature_name"] : delete f["uuid"];
        setFilters(f);
    };

    const featureSearch = () => {
        getData(filters);
    };

    const onSelectFeature = (event) => {
        let f = form;
        let value = event.target.value as string;
        f["feature_uuid"] = value;

        setForm(JSON.parse(JSON.stringify(f)));
        validateForm(JSON.parse(JSON.stringify(f)));
    };

    const validateForm = (f) => {
        if (f["feature_uuid"] && f["customers"].length > 0) {
            setIsValidForm(false);
        } else {
            setIsValidForm(true);
        }
    };

    const onReset = () => {
        setSearch("");
        setFilters({});
    };

    useEffect(() => {
        if (!open) {
            setFilters({})
            setIsValidForm(true)
            setSearch("");
            setFeatureList(JSON.parse(JSON.stringify([])));
            setForm({
                feature_uuid: "",
                customers: [],
            });
        } else {
            setForm({
                feature_uuid: "",
                customers: [customer]
            });
        }
        featureService.current = new FeatureService(changeAlert);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    return {
        form,
        loading,
        featureList,
        isValidForm,
        filters,
        zPos,
        search,
        onSelectFeature,
        changeValueSearch,
        featureSearch,
        onReset,
    };
};
